import React from 'react';
import bus from 'assets/images/movimiento-bus.png';

export default function Movimiento() {
  return (
    <div className='movimiento'>
        <div className="logo">
            <h3>Incluir en movimiento</h3>
        </div>
        <figure>
            <img src={bus} alt="Imagen de bus" />
        </figure>
        <figcaption>
            <p>Presentamos el ciclo itinerante de educación financiera que llega a distintas localidades de la Provincia</p>
            <a className="btn-verde" href="/movimiento">Conocé más</a>
        </figcaption>
    </div>
  );
}